import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { getUSDstring } from '../../../utils/helpers'
import Dialog from '../Dialog/index'
import { ReactComponent as CheckMarkIcon } from './CheckMark.svg'
import styles from './PaymentCompleteDialog.module.scss'
import { TurnOnAutoPayments } from './TurnOnAutoPayments'

const PaymentCompleteMessage = ({ amount = 0, showEnableAutoPay, isProcessed }) => (
  <div className={styles.dialog}>
    <div className={styles.content}>
      <div className={styles.title}>
        <CheckMarkIcon />
        Payment complete
      </div>
      {isProcessed ? (
        <p>Your payment for {getUSDstring(`${amount}`)} is processed succesfully.</p>
      ) : (
        <p>
          Your payment for {` `}
          <b>{getUSDstring(`${amount}`)}</b> is being processed. Please allow 2 business
          days from the payment date for the amount to post to your account.
        </p>
      )}

      <p></p>
    </div>
    {!showEnableAutoPay && (
      <div className={styles.controls}>
        <Link to="/billing">
          <button className={styles.primaryButton}>Ok</button>
        </Link>
      </div>
    )}
  </div>
)

const PaymentCompleteDialog = ({
  amount,
  showEnableAutoPay,
  handleEnableClick,
  isAutoPayEnabled,
  isProcessed
}) => (
  <Dialog>
    <div className={styles.wrapper}>
      <PaymentCompleteMessage
        amount={amount}
        showEnableAutoPay={showEnableAutoPay}
        isProcessed={isProcessed}
      />
      {showEnableAutoPay && (
        <TurnOnAutoPayments
          handleEnableClick={handleEnableClick}
          isEnabled={isAutoPayEnabled}
          paymentMethodName="Visa ending with 1234"
        />
      )}
    </div>
  </Dialog>
)

PaymentCompleteDialog.propTypes = {
  handleEnableClick: PropTypes.func
}

export default PaymentCompleteDialog
